// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__2TRVV","header":"Login_header__3Rqyp","body":"Login_body__298H0","center":"Login_center__19x12"};